<lang-change></lang-change>
<div class="container login-container" appDynamicDirection>
    <div class="card card-container">
        <p id="profile-name" class="profile-name-card" i18n>Comments and Questions on SDG-PSS</p>
        <p class="description-text" i18n>While using SDG-PSS, you may have a question, or a comment related to a specific aspect of the tool. Please use the space below. A member of the project team will follow-up.</p>

        <form name="form" (ngSubmit)="f.form.valid && submitFeedback()" #f="ngForm" novalidate>

            <div class="sdg-two-column-row">
                <div class="sdg-field-column">
                    <label for="full_name" class="sdg-label" i18n>Your Full Name</label>
                    <input type="text" class="sdg-input" name="full_name" [(ngModel)]="model.full_name" #full_name="ngModel" required id="full_name" />
                    <div *ngIf="f.submitted && !full_name.valid" class="help-block" i18n>Your Full Name is required</div>
                </div>

                <div class="sdg-field-column">
                    <label for="email" class="sdg-label" i18n>Your E-mail Address</label>
                    <input type="email" pattern="[^ @]*@[^ @]*" class="sdg-input" name="email" [(ngModel)]="model.email" #email="ngModel" required id="email"/>
                    <div *ngIf="f.submitted && !email.valid" class="help-block" i18n>Please enter a valid Email</div>
                </div>
            </div>

            <div class="sdg-country-row">
                <label for="country" class="sdg-label" i18n>Your Country</label>
                <input type="text" class="sdg-input-full" name="country" [(ngModel)]="model.country" #country="ngModel" required id="country"/>
                <div *ngIf="f.submitted && !country.valid" class="help-block" i18n>Country is required</div>
            </div>

            <div class="sdg-message-label-row">
                <label for="comment" class="sdg-label" i18n>Your Message</label>
            </div>

            <div class="sdg-textarea-row">
                <textarea class="sdg-textarea" name="comment" [(ngModel)]="model.comment" #comment="ngModel" required id="comment"></textarea>
                <div *ngIf="f.submitted && !comment.valid" class="help-block" i18n>Comment is required</div>
            </div>

            <div class="form-group">
                <button [disabled]="loading" class="btn btn-primary btn-radius btn-block">
                    <span *ngIf="!loading" i18n>Submit</span>
                    <span *ngIf="loading">
                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAAEAAQAAADzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" style="width: 16px; height: 16px; vertical-align: middle;" />
                        <span i18n>Submitting...</span>
                    </span>
                </button>
                <a [routerLink]="['/home']" class="btn btn-default btn-block btn-radius" i18n>Cancel</a>
            </div>
        </form>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/feedback/feedback.component.html